<div fxLayout="column">
  <ng-container *ngIf="jobStatus.status === JobStatus.IN_PROGRESS || jobStatus.status === JobStatus.WAITING">
    <div fxFlex fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
      <mat-spinner mode="indeterminate" color="accent" diameter="64" strokeWidth="5"></mat-spinner>
      <span>Aggiornamento in elaborazione...</span>
    </div>
  </ng-container>

  <ng-container *ngIf="jobStatus.status === JobStatus.ERROR">
    <h2>Errore</h2>

    <ul fxFlex>
      <li *ngFor="let error of jobStatus.errors">
        <span>{{ error }}</span>
      </li>
    </ul>
  </ng-container>

  <ng-container *ngIf="jobStatus.status === JobStatus.COMPLETED">

    <div fxLayout="column">

      <form [formGroup]="form">

        <!-- Related companies form -->
        <div style="margin-top:24px">
          <div class="mat-h2"> {{ getTitle() }} </div>
          <div formArrayName="relatedCompanies"
               *ngFor="let group of relatedFormsGroups().controls; let index=index; let last = last">

            <div style="margin-top:16px" [formGroupName]=index>

              <div style="margin:8px 0" class="mat-h3">{{ getRelatedCompanyDescription(index) }}</div>

              <!--Firstname and lastname-->
              <div fxLayout="row" fxLayoutGap="16px">
                <mat-form-field fxFlex="50" appearance="fill">
                  <mat-label>Nome contatto</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="legalRepresentativeFirstName" />
                </mat-form-field>

                <mat-form-field fxFlex="50" appearance="fill">
                  <mat-label>Cognome contatto</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="legalRepresentativeLastName"
                    required />
                </mat-form-field>
              </div>

              <!--Mail and Phone  -->
              <div fxLayout="row" fxLayoutGap="16px">
                <mat-form-field fxFlex="50" appearance="fill">
                  <mat-label>Email contatto</mat-label>
                  <input
                    matInput
                    type="email"
                    formControlName="legalRepresentativeEmail"
                    required
                  />
                </mat-form-field>

                <mat-form-field fxFlex="50" appearance="fill">
                  <mat-label>Telefono contatto</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="legalRepresentativePhone" />
                </mat-form-field>
              </div>

              <mat-divider *ngIf="!last"></mat-divider>

            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-container>
</div>
